import { permissionsSelector } from "../modules/Login/selectors/permissionSelector";
import { useRecoilValue } from "recoil";
import {
  InputHTMLAttributes,
  TextareaHTMLAttributes,
  DetailedHTMLFactory,
  useState,
} from "react";
import { UseFormRegisterReturn } from "react-hook-form";

interface ITextAreaHookForm
  extends DetailedHTMLFactory<
    TextareaHTMLAttributes<HTMLTextAreaElement>,
    HTMLTextAreaElement
  > {
  className?: string;
  areaType?: boolean;
  label?: string;
  preIcon?: any;
  register?: UseFormRegisterReturn;
  validation?: any;
  hasPermission?: boolean;
  secondDiv?: string;
  ref?: any;
  disabled?: boolean;
  maxLength?: number;
  name?: string;
}
const TextAreaHookForm: React.FC<ITextAreaHookForm> = ({
  className = "border border-gray-300 focus:ring-septenary focus:border-septenary",
  disabled = false,
  secondDiv = "md:grid-cols-2",
  ref,
  register,
  name,
  validation,
  maxLength,
  ...props
}) => {
  const [focus, setFocus] = useState(false);
  const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <div className="space-y-1 w-full text-xs">
      <div className={`grid ${secondDiv} w-full items-center gap-2`}>
        {props.label && (
          <label className="flex space-x-1 justify-start expandedLabel fontExpand">
            {validation &&
              validation.required &&
              validation.required.value === true && (
                <span className="text-red-500 pl-1 font-bold">*</span>
              )}
            {props.label}:
          </label>
        )}
        <textarea
          className={`block w-full h-100 bg-white bg-clip-padding leading-normal outline-none
            px-1 py-1 text-xs sm:text-xs rounded-sm ${className} ${
            disabled && "opacity-50"
          }`}
          {...register}
          disabled={disabled}
          maxLength={maxLength}
          {...props}
        />
      </div>
    </div>
  );
};
export default TextAreaHookForm;
